import { render, staticRenderFns } from "./QuejasReclamos.vue?vue&type=template&id=8f3c1f24&"
import script from "./QuejasReclamos.vue?vue&type=script&lang=js&"
export * from "./QuejasReclamos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports